import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepartmentLookupComponent } from './department-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [DepartmentLookupComponent],
  exports: [DepartmentLookupComponent]
})
export class DepartmentLookupModule { }
